import { t } from '@bms2/shared';
import { Modal } from '../../components/modals/Modal';
import modalStyles from '../../components/modals/modal.module.css';
import styles from './settings.module.css';

/**
 * 🔒 The hand-over window (decision 0482): an in-person code or a temporary
 * password is shown ONCE, in a window of its own that says it will not be
 * shown again. Settings › People › Logins draws it after an invitation, a
 * resend and an issued temporary password, and the Hire window after a hire on
 * a hand-over channel (T3007). 🔨 The caller mounts it only while there is a
 * secret to show and unmounts it on close, so the secret does not sit in the
 * page behind a flag after the person has finished with it.
 */
export function HandOverWindow({ secret, onClose }: { secret: string; onClose: () => void }) {
  return (
    <Modal
      open
      title={t('settings.logins.handOverTitle')}
      onCancel={onClose}
      dataModal="hand-over-password"
      /* 🔨 A modal footer holds exactly one primary and one cancel (piece 5); both here close it, because acknowledging and closing are the same act. */
      actions={[
        { kind: 'primary', label: t('settings.logins.handOverDone'), onAct: onClose },
        { kind: 'cancel', label: t('modal.close'), onAct: onClose },
      ]}
    >
      <p className={modalStyles.hint}>{t('settings.logins.handOverWhat')}</p>
      <p className={styles.emphasis} data-hand-over-secret>{secret}</p>
    </Modal>
  );
}
